import {Component, OnInit} from '@angular/core';
import {ClientesUsuariosModel} from "./clientes-usuarios.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {AdmClientesUsuariosService} from "./adm-clientes-usuarios.service";
import {FormBuilder, FormGroup} from "@angular/forms";

declare let swal, $: any;

@Component({
  selector: 'app-clientes-usuarios',
  templateUrl: './clientes-usuarios.component.html'
})
export class ClientesUsuariosComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"nome":"", "email":"", "status_pesquisa":""};

  usuarios: ClientesUsuariosModel[] = [];
  listStatus = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listStatusUsuarios = [{
    "texto": "Ativo",
    "valor": 5
  },{
    "texto": "Não Confirmado",
    "valor": 8
  },{
    "texto": "Bloqueado",
    "valor": 9
  }];

  constructor(
    formBuilder: FormBuilder,
    private usuariosService: AdmClientesUsuariosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'clientes'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      email: [],
      status_pesquisa: []
    });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.atualizaUsers();

    this.usuariosService.getListStatus()
      .subscribe(
        json => {
          this.listStatus = json.Payload;

          if (this.global.debug) {
            console.log(this.listStatus);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

  }

  atualizaUsers(){
    this.getPage(1);
  }

  deleteUser(user) {
    let usuarios = this.usuarios;
    let usuariosService = this.usuariosService;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarUsuario')+user.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      () => {
        if(this.global.debug == true){
          console.log(usuarios);
        }

        var index = usuarios.indexOf(user);
        usuarios.splice(index, 1);

        usuariosService.apagar(user.id_usuario)
          .subscribe(res => {
              //swal(this.func.traduzir('back.deletado'), this.func.traduzir('back.removidoComSucesso'), "success");
              this.usuarios = usuarios;
            },
            error => {
              //swal(this.func.traduzir('back.erro'), this.func.traduzir('back.registroNaoRemovido'), "error");
              // Revert the view back to its original state
              usuarios.splice(index, 0, user);
              this.usuarios = usuarios;
              usuariosService.trataErro(error.json());
            });
      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.status_pesquisa != ''){
      filtros['id_status'] = this.filtroPesquisa.status_pesquisa;
    }

    if(this.filtroPesquisa.nome != ''){
      filtros['nome'] = '**:'+this.filtroPesquisa.nome;
    }
    if(this.filtroPesquisa.email != ''){
      filtros['email'] = '**:'+this.filtroPesquisa.email;
    }

    this.usuariosService.getPaginacao(pagina,this.itensPorPagina,['status', 'cliente'], filtros)
      .subscribe(data => {
        this.usuarios = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },error => {
        this.trataErro(error.json());
        this.carregandoTabela = false;
      });
  }

  solicitarNovaSenha(user){

    let usuariosService = this.usuariosService;

    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaSolicitarNovaSenha')+user.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){


        usuariosService.solicitarNovaSenha(user.email)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.emailEnviadoUsuario'), "success");
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.emailNaoEnviadoUsuario'), "error");

              self.func.showErro(error.json());
            });

      });

  }

  alteraStatus(id_usuario, id_status){

    let usuariosService = this.usuariosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaAlterarStatus'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        usuariosService.setStatus(id_usuario, id_status)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");

              self.atualizaUsers();
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");

              self.func.showErro(error.json());
            });

      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"nome":"", "email":"", "status_pesquisa":""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/clientes-usuarios/clientes-usuarios.component.ts